import React from 'react'
import './index.less'

interface SectionTitleProps {
	title: string
	subtitle: string
	description?: string
	titleColor?: string
	subtitleColor?: string
	desColor?: string
}

function SectionTitle(props: SectionTitleProps) {
	const {
		title,
		subtitle,
		description,
		titleColor = '#030f2d',
		subtitleColor = '#0022550f',
		desColor = '#030f2d80',
	} = props
	return (
		<div className="section-title">
			<h1 style={{ color: titleColor }}>{title}</h1>
			<h2 style={{ color: subtitleColor }}>{subtitle}</h2>
			{description && (
				<p
					style={{ color: desColor }}
					dangerouslySetInnerHTML={{ __html: description }}
				></p>
			)}
		</div>
	)
}

export default SectionTitle
